export default {
  init() {

  },
  finalize() {

    const $burgerToggle = $('.menu-burger-toggle');
    const $header = $('header#header');
    const $navMobile = $('.nav-mobile');

    $burgerToggle.on('click', function() {
      $navMobile.toggleClass('open');
      $header.toggleClass('open');
    });

  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/navigationMobile.js